export default class TemplateTextAreaBinding {
  constructor(fieldName, isExist, value, maxLength) {
    this.fieldName = fieldName;
    this.isExist = isExist;
    this.value = value;
    this.maxLength = maxLength;
  }
}
